<template>
    <div class="bg-white rounded-md px-3 py-4 mb-2 lg:bg-transparent lg:rounded-none">
        <div class="text-lg font-semibold">{{ cart.$state.bundle?.description }}</div>
        <div
            class="lg:block"
            :class="{ 'hidden': !store.$state.steps.showOrderDetails.open }"
        >
            <!-- BUNDLE ITEMS -->
            <div class="bundle__item">
                <!-- PLAN -->
                <template v-if="cart.$state.bundle?.plan">
                    <div class="text-lg font-semibold">
                        Membership
                    </div>
                    <LineItem>
                        <template #default>
                            <span class="capitalize">
                                {{ cart.$state.bundle.plan.group_key }} Plan
                            </span>
                        </template>
                        <template #description>
                            <span class="capitalize">
                                {{ cart.$state.bundle.plan.billing_interval }} membership
                            </span>
                        </template>
                        <template #price v-if="isHolidayBundle">
                            <del class="text-[#6E7086] font-normal">$355.00</del> $249.00
                        </template>
                    </LineItem>
                </template>
            </div>

            <div class="bundle__item">
                <!-- EQUIPMENT -->
                <div class="text-lg font-semibold">
                    Equipment
                </div>
                <template v-if="cart.$state.bundle?.equipment?.length">
                    <LineItem
                        v-for="equipment in cart.$state.bundle.equipment"
                        :key="equipment.stripe_price_id"
                    >
                        <template #default>
                            {{ equipment.label }}
                        </template>
                        <template #description>
                            <div>{{ equipment.description }}</div>
                        </template>
                        <template #price v-if="isHolidayBundle">
                            {{ equipment.label == 'Meta Quest 3S Headset' ? '$299.00' : 'Free' }}
                        </template>
                    </LineItem>
                </template>
            </div>
        </div>

        <!-- TOTALS -->
        <TotalSection
            class="bundle__item"
            :total-only="!store.$state.steps.showOrderDetails.open"
        />

        <!-- SHOW DETAILS -->
        <div class="lg:hidden">

            <button
                type="button"
                class="text-blue-700 text-left content-start px-0 justify-between flex w-full items-center gap-2 py-2 uppercase font-semibold text-sm"
                @click="store.$state.steps.showOrderDetails.open = !store.$state.steps.showOrderDetails.open"
            >
                <span>
                    {{ store.$state.steps.showOrderDetails.open ? 'Hide' : 'Show' }} Order Details
                </span>
                <ChevronDownIcon
                    class="h-5 w-5"
                    :class="{
                        'transform rotate-180': store.$state.steps.showOrderDetails.open,
                    }"
                />
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ChevronDownIcon } from '@heroicons/vue/24/solid'
import { useCheckoutStore } from '@/store/checkout'
import { useCartStore } from '@/store/cart'
import TotalSection from '@/components/Shared/TotalSection.vue'
import LineItem from '@/components/Shared/LineItem.vue'

const store = useCheckoutStore()
const cart = useCartStore()

const isHolidayBundle = cart.bundle?.bundle_group_key === 'metaquest3s-holiday'
</script>

<style>
.bundle__item {
    @apply flex flex-col gap-4 text-base font-medium my-3 border-t-2 border-gray-300 pt-3;
}
</style>
